export default {
  title: 'Academic Load',
  downloadExcel: 'Download Excel',
  hoursDetail: 'Hours Detail (weekly)',
  hoursTotals: 'Hours Totals',
  maximumQuota: 'Maximum Quota and Requirement',
  classroomType: 'Classroom type',
  periodicity: 'Periodicity',
  order: 'Order',
  goToMatter: 'Go to course',
  period: 'Period (Semester)',
  internalCode: 'Internal course code',
  code: 'Course Key',
  name: 'Name',
  prerequisites: 'Prerequisite',
  pucvCredits: 'PUCV Cr.',
  sctCredits: 'SCT Cr.',
  presentialWeekly: 'Total weekly in-person teaching hours',
  presentialSemester: 'Total semester in-person teaching hours',
  autonomousWeekly: 'Total weekly autonomous study time',
  autonomousSemester: 'Total semester autonomous study time',
  dedicationWeekly: 'Total weekly dedication hours',
  dedicationSemester: 'Total semester dedication hours',
  quotaJustification: 'Quota justification',
  observation: 'Observation / Simultaneous teachers / Assistants',
  periodicities: {
    weekly: 'Weekly',
    monthly: 'Monthly',
    bimonthly: 'Bimonthly',
    semiannual: 'Semiannual',
  },
  selectPrerequisites: 'Select prerequisites',
  editPrerequisites: 'Edit prerequisites',
  searchMatter: 'Search course...',
  // Totals of a single subject (MatterForm and program presentation)
  matterTotals: {
    presential: 'Total in-person teaching hours Weekly/ Semester PUCV',
    autonomous: 'Total autonomous personal study time Weekly/ Semester PUCV',
    dedication: 'Total dedication hours Weekly/ Semester PUCV',
    weekly: '{hours} weekly PUCV pedagogical hours',
    semester: '{hours} PUCV pedagogical hours per semester',
  },
  autonomousNegative:'In-person hours ({presential}) exceed the {weekly} weekly hours allowed by {credits} PUCV credits.',
  presentialOverRatio:'In-person hours ({presential}) exceed 40% ({max}) of the {weekly} weekly hours of {credits} PUCV credits: autonomous work must be at least 60%.',
  hoursHint: 'Weekly hours. They are saved multiplied by the {weeks} weeks of the course.',
  closedMatter: 'Closed course: read only.',
  noMatters: 'The egress profile has no courses.',
  changeMade: 'Change saved',
  codeAlreadyUsed: 'The code {code} is already used by another base course of the institution.',
  columnsSelector: {
    subject: 'Course',
    totals: 'Hours totals',
    presential: 'In-person teaching',
    autonomous: 'Autonomous study',
    dedication: 'Dedication',
    divisions: 'Time divisions',
    all: 'All',
    hours: 'Hours',
    quota: 'Quota',
    classroomType: 'Room',
    periodicity: 'Periodicity',
    observation: 'Observation',
    showAll: 'Show all',
    hiddenCount: 'Columns ({count} hidden)',
  },
};
